import cdn from '@SHARED/js/helpers/cdn';

// Helper to make cdn() available in Vue templates
export default {
  methods: {
    cdn,
  },
};
